/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A URL template variable for a remote MCP server
 */
export type ExternalMCPRemoteVariable = {
  /**
   * Allowed values for the variable
   */
  choices?: Array<string> | undefined;
  /**
   * Default value for the variable
   */
  default?: string | undefined;
  /**
   * Description of the variable
   */
  description?: string | undefined;
  /**
   * Whether this variable is required
   */
  isRequired?: boolean | undefined;
  /**
   * Whether this variable value should be treated as secret
   */
  isSecret?: boolean | undefined;
};

/** @internal */
export const ExternalMCPRemoteVariable$inboundSchema: z.ZodMiniType<
  ExternalMCPRemoteVariable,
  unknown
> = z.pipe(
  z.object({
    choices: z.optional(z.array(z.string())),
    default: z.optional(z.string()),
    description: z.optional(z.string()),
    is_required: z.optional(z.boolean()),
    is_secret: z.optional(z.boolean()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "is_required": "isRequired",
      "is_secret": "isSecret",
    });
  }),
);

export function externalMCPRemoteVariableFromJSON(
  jsonString: string,
): SafeParseResult<ExternalMCPRemoteVariable, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ExternalMCPRemoteVariable$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ExternalMCPRemoteVariable' from JSON`,
  );
}
